module.exports = __webpack_public_path__ + "img/book-solid.5d7cd605.svg";